module.exports = __webpack_public_path__ + "media/images/icon-calendar-b1c87999fe8da2728169081e82925d32.svg";